// extracted by mini-css-extract-plugin
module.exports = {"container":"visitedShops_container__qbiYN","title":"visitedShops_title__iJaWE","swiperSlide":"visitedShops_swiperSlide__tRyiz"};